<template>
  <div>
    <v-chip :color="data ? 'green' : 'red'" text-color="white">
      {{ data ? "Медосмотр пройден" : "Медосмотр не пройден" }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "Result",
  props: {
    data: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
